import emailSpellChecker from '@zootools/email-spell-checker';
import {FORM_INPUTS} from "../utils/formInputs";
import {createEmailSuggestionElement} from "../utils/emailSuggestion";

const inputFields = document.querySelectorAll('#userForm input, #phasePayment input, #phasePayment select, #fullDataForm input, #fullDataForm select, #userForm select');

const watchProperty = (obj, name, handler) => {
    if(obj.value.length > 0) {
        handler.call(obj);
    }

    if ('watch' in obj) {
        obj.watch(name, handler);
    } else if ('onpropertychange' in obj) {
        name= name.toLowerCase();
        obj.onpropertychange= function() {
            if (window.event.propertyName.toLowerCase()===name)
                handler.call(obj);
        };
    } else {
        let o= obj[name];
        setInterval(function() {
            var n= obj[name];
            if (o!==n) {
                o= n;
                handler.call(obj);
            }
        }, 200);
    }
}

export const initValidation = () => {
    if(!inputFields) return;

    for (let i = 0; i < inputFields.length; i++) {
        const input = inputFields[i];
        const pattern = new RegExp(input.getAttribute('pattern'));
        const isRequired = input.getAttribute('required');
        const isMinLength = input.getAttribute('minlength');
        const isPattern = input.getAttribute('pattern');

        watchProperty(input, 'value', () => {
            input.classList.add('touched');
            input.value.length === 0 ? input.classList.remove('has-content') : input.classList.add('has-content');

            if (isRequired === null) return;

            if (
                pattern.test(input.value) ||
                (isMinLength && isMinLength <= input.value.length) ||
                (!isPattern && !isMinLength && input.value.length > 0)
            ) {
                makeValidElement(input);
            } else {
                makeInvalidElement(input);
            }
        });
    }
};

const makeValidElement = (el) => {
    el.classList.remove('invalid');
    el.classList.add('valid');
};

const makeInvalidElement = (el) => {
    el.classList.remove('valid');
    el.classList.add('invalid');
};

export const checkEmailSpell = () => {
    FORM_INPUTS.email.element.addEventListener('blur', ()=> {
        const suggestion = emailSpellChecker.run({
            email: FORM_INPUTS.email.element.value
        })

        if (suggestion) {
            createEmailSuggestionElement(suggestion.full);
        }
    });
}

export const checkIfValid = () => Array.from(inputFields).some(element => element.classList.contains('invalid'));
